import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import Linkify from 'linkify-react';
import './htmlPreview.css';

export default function StyledTextPreview({ text, color }) {

    const isHTMLText = (text) => {
        var isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
        return isHTML(text)
    }

    const renderText = (text) => {
        if (isHTMLText(text)) {
            let sanitizedContent = DOMPurify.sanitize(text, {
                ADD_ATTR: ['target']
            });
            return parse(sanitizedContent)
        } else {
            if (typeof text === 'object') {
                return JSON.stringify(text)
            }
            return text
        }
    }

    return (
        <div className="oz-safe-html-text-preview" style={{ overflowWrap: 'anywhere', color: color }}>
            <Linkify options={{ target: '_blank' }}> {renderText(text)}</Linkify>
        </div>
    )
}
